import { CategoryFileFragment } from './graphql/fragment/generated/CategoryFile';

export interface CategoryType extends CategoryFileFragment {
  childCategories?: CategoryType[];
}

export type CategoryLayoutView = 'edit' | 'single-select' | 'multi-select';

export enum CategoryActionsEnum {
  RenameCategory = 'RenameCategory',
  AddSubcategory = 'AddSubcategory',
  MergeCategory = 'MergeCategory',
  DeleteCategory = 'DeleteCategory',
}

export enum CategoryDialogsEnum {
  MergeCategory = 'MergeCategory',
  DeleteCategory = 'DeleteCategory',
}

export type CategoryDialogActions =
  | {
      action: 'delete';
      payload: { category: CategoryType };
    }
  | {
      action: 'merge';
      payload: { category: CategoryType; newParentCategory: CategoryType };
    }
  | { action: 'close' };

export interface CategoryDialogsState {
  inViewDialog: CategoryDialogsEnum;
  selectedCategory: CategoryType;
}
